/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum CompleteStopStatus {
  arrived="arrived",
done="done",
skipped="skipped",
on_the_way="on_the_way",
departed="departed"
}

/**
* CompleteStopStatus
*/
export const CompleteStopStatusEnumType = types.enumeration("CompleteStopStatus", [
        "arrived",
  "done",
  "skipped",
  "on_the_way",
  "departed",
      ])
